import React from 'react'
import { Page, Text, View, Document, Image, StyleSheet, PDFViewer, Font } from '@react-pdf/renderer';
import { Box } from '@mui/system';
import SourceSerifPro from '../../../../fonts/SourceSerifPro-Regular.ttf';
import moment from 'moment';

// utils
import { generatePages, calculateTotalWeight, generateColumns } from './PDFGenerator.collection.utils';

// assets
import logo from '../../../../assets/images/logo.jpg'

// mui
import { Alert, AlertTitle, backdropClasses } from '@mui/material';

Font.register({ family: "source-serif-pro", src: SourceSerifPro})

// Create styles
const styles = StyleSheet.create({
  page: {
    fontFamily: "source-serif-pro",
    fontSize: "12px",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    padding: "20px",
  },
  logo: {
    width: "78px"
  },
  title: {
    width: "100%",
    textAlign: "left",
    fontSize: "24px",
    marginBottom: "8px"
  },
  multiColumnContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
    paddingRight: "16px",
    paddingBottom: "8px",
    paddingTop: "8px",
    textAlign: "left",
    // backgroundColor: "green",
  },
  leftAlignedColumn: {
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    textAlign: "left",
    flex: 1,
    // backgroundColor: "red"
  },
  leftColumn: {
    flex: 1,
    // backgroundColor: "red"
  },
  middleColumn: {
    flex: 1,
    textAlign: "center"
    // backgroundColor: "red"
  },
  rightColumn: {
    flex: 1,
    textAlign: "right",
    // backgroundColor: "red"
  },
  equipment: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    // backgroundColor: "red"
  },
  equipmentContainer: {
    width: "30%",
    padding: 4,
    display: "flex",
    flexDirection: "column",
    // backgroundColor: "green",
  },
  itemContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: "4px",
    marginBottom: "4px"
    // backgroundColor: "yellow"
  },
  categoryContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    borderBottom: "1px solid black",
    marginTop: "8px",
    // backgroundColor: "yellow"
  },
  equipmentMainColumn: {
    flex: 12,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    // backgroundColor: "red",
  },
  equipmentMainColumnName: {
    flex: 8
  },
  equipmentMainColumnQuantity: {
    flex: 2,
    marginLeft: "8px"
  },
  equipmentCheckbox: {
    width: "24px",
    height: "24px",
    border: "1px solid black",
    borderRadius: "4px",
    marginRight: "8px",
    // backgroundColor: "yellow"
  },
  horizontalRule: {
    height: "2px",
    width: "100%",
    backgroundColor: "black",
    marginTop: "8px",
    marginBottom: "8px"
  },
});

const PDFGenerator = ({ data, loading, error }) => {

    if(loading) return null

    if(error) {
      return (<Alert severity="error">
        <AlertTitle>Unable to Generate PDF</AlertTitle>
        {error.message}
      </Alert>)
    }

    const { equipmentRequest } = data;
    const totalWeight = calculateTotalWeight(equipmentRequest.equipmentRequestItemsForEquipmentRequest)
    const columns = generateColumns(equipmentRequest.equipmentRequestItemsForEquipmentRequest, 17)
    const pages = generatePages(columns)

    console.info(pages)

    return (<Box sx={{ width: "100%", height: "80vh"}}>
    <PDFViewer width={"100%"} height={"100%"}>
        <Document>

            {
              Object.keys(pages).map((pageKey, index) => {

                const page = pages[pageKey]
                console.info(index)
                return (<Page size="LETTER" style={styles.page}>
                  {
                    index == 0 && (<React.Fragment>
                      <View>
                        <Text style={styles.title}>{equipmentRequest.job.name}</Text>
                      </View>

                      <View style={styles.multiColumnContainer}>
                        <View style={styles.leftAlignedColumn}>
                          <View><Text>{equipmentRequest.job.street1}</Text></View>
                          <View><Text>{equipmentRequest.job.city}, {equipmentRequest.job.state} {equipmentRequest.job.zipcode}</Text></View>
                        </View>
                        <View style={styles.middleColumn}>
                          <View><Text>Truck #{equipmentRequest.truck.number}</Text></View>
                          <View><Text>{totalWeight} lbs</Text></View>
                        </View>
                        <View style={styles.rightColumn}>
                          <View><Text>{equipmentRequest.requestedBy.firstName} {equipmentRequest.requestedBy.lastName}</Text></View>
                          <View><Text>{moment(equipmentRequest.datetimeCreated).format("MM/DD/YYYY")}</Text></View>
                        </View>
                      </View>
                    

                    <View style={styles.horizontalRule}></View>
                    </React.Fragment>)
                  }

                  {/* Equipment List */}
                  <View style={styles.equipment}>
                    {
                      page.map(column => {
                        return (<View style={styles.equipmentContainer}>
                          {
                            column.map(item => {
                              if(item.type == "category"){
                                return (<View style={styles.categoryContainer}>
                                  <View style={styles.equipmentMainColumn}>
                                    <Text>{item.value}</Text>
                                  </View>
                                </View>)
                              } 
                              else if(item.type == "item"){
                                return (<View style={styles.itemContainer}>
                                  <View style={styles.equipmentCheckbox} />
                                  <View style={styles.equipmentMainColumn}>
                                    <Text style={styles.equipmentMainColumnName}>{item.value.equipment.name}</Text>
                                    <Text style={styles.equipmentMainColumnQuantity}>{item.value.requestedQuantity}</Text>
                                  </View>
                                </View>)
                              }
                            })
                          }
                        </View>)
                      })
                    }
                  </View>

                  {
                    (index == Object.keys(pages).length - 1) && (<React.Fragment>
                      <View style={styles.horizontalRule}></View>

                      <View>
                        <Text>{equipmentRequest.notes}</Text>
                      </View>
                    </React.Fragment>)
                  }
                
                </Page>)
              })
            }
            
        </Document>
    </PDFViewer>
  </Box>)
}

export default PDFGenerator;


/*
<Page size="LETTER" style={styles.page}>

              <View>
                <Text style={styles.title}>{equipmentRequest.job.name}</Text>
              </View>

              <View style={styles.multiColumnContainer}>
                <View style={styles.leftAlignedColumn}>
                  <View><Text>{equipmentRequest.job.street1}</Text></View>
                  <View><Text>{equipmentRequest.job.city}, {equipmentRequest.job.state} {equipmentRequest.job.zipcode}</Text></View>
                </View>
                <View style={styles.middleColumn}>
                  <View><Text>Truck #{equipmentRequest.truck.number}</Text></View>
                  <View><Text>{totalWeight} lbs</Text></View>
                </View>
                <View style={styles.rightColumn}>
                  <View><Text>{equipmentRequest.requestedBy.firstName} {equipmentRequest.requestedBy.lastName}</Text></View>
                  <View><Text>{moment(equipmentRequest.datetimeCreated).format("MM/DD/YYYY")}</Text></View>
                </View>
              </View>
              

              <View style={styles.horizontalRule}></View>

              {/* Equipment List
              <View style={styles.equipment}>
                {
                  Object.keys(columns).map(columnKey => {
                    const column = columns[columnKey]

                    return (<View style={styles.equipmentContainer}>
                      {
                        column.map(item => {
                          if(item.type == "category"){
                            return (<View style={styles.categoryContainer}>
                              <View style={styles.equipmentMainColumn}>
                                <Text>{item.value}</Text>
                              </View>
                            </View>)
                          } 
                          else if(item.type == "item"){
                            return (<View style={styles.itemContainer}>
                              <View style={styles.equipmentCheckbox} />
                              <View style={styles.equipmentMainColumn}>
                                <Text style={styles.equipmentMainColumnName}>{item.value.equipment.name}</Text>
                                <Text style={styles.equipmentMainColumnQuantity}>{item.value.requestedQuantity}</Text>
                              </View>
                            </View>)
                          }
                        })
                      }
                    </View>)
                  })
                }
              </View>

              

            </Page>

*/